import { useGraphQLSuspenseQuery } from '@betterment/graphql';

import { Notification } from './FirmIntegrationsPage';
import { OutboundIntegrationsDocument } from './graphql/query.firmIntegrations.generated';
import IntegrationConnectCard from './IntegrationCard/IntegrationConnectCard';
import IntegrationListContainer from './IntegrationListContainer';

import { OutboundIntegration } from '../../graphql/schema';
import { IdempotencyProviderWithFeatureRegistry } from '../../providers/IdempotencyProviderWithFeatureRegistry';

const IntegrationConnectList: React.FC<{ setNotification: (notification: Notification) => void }> = ({
  setNotification,
}) => {
  const { data } = useGraphQLSuspenseQuery(OutboundIntegrationsDocument);

  return (
    <IntegrationListContainer>
      {data.outboundIntegrations?.map((integration: OutboundIntegration) => (
        <IdempotencyProviderWithFeatureRegistry featureName="firmIntegrations" key={integration.id}>
          <IntegrationConnectCard integration={integration} setNotification={setNotification} />
        </IdempotencyProviderWithFeatureRegistry>
      ))}
    </IntegrationListContainer>
  );
};

export default IntegrationConnectList;
